import React from "react";

interface PercentageBarProps {
  percentage: number;
  width?: string;
  highlightThreshold?: number;
}

const PercentageBar: React.FC<PercentageBarProps> = ({ percentage, width = "100%", highlightThreshold = 85 }) => {
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100);
  const isHighlighted = clampedPercentage > highlightThreshold;

  const barColorClass = isHighlighted ? "bg-green-600" : "bg-gray-300";

  return (
    <div className="relative w-full rounded-full bg-gray-200 overflow-hidden" style={{ width }}>
      <div
        className={`h-6 rounded-full transition-all duration-300 ${barColorClass}`}
        style={{ width: `${clampedPercentage}%` }}
      />
      <div className="absolute inset-0 flex items-center justify-center text-xs font-medium text-secondary-900">
        {percentage > 100 ? "⬆" : ""}
        {clampedPercentage.toFixed(2)}%
      </div>
    </div>
  );
};

export { PercentageBar };
